import { render, staticRenderFns } from "./Placas.vue?vue&type=template&id=5c510e7c&scoped=true&"
import script from "./placas.js?vue&type=script&lang=js&"
export * from "./placas.js?vue&type=script&lang=js&"
import style0 from "./Placas.vue?vue&type=style&index=0&id=5c510e7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c510e7c",
  null
  
)

export default component.exports